(function () {
    'use strict';

    angular.module("imApp").factory("counterService", ['$ihttp', function ($ihttp) {
        let service = {
            getCounter: function (parms) {
                return $ihttp.post({
                    method: 2555,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2556,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
